<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <div class="pt-12">
          <div class="text-center">
            <v-icon size="96" color="success">
              mdi-clock-outline
            </v-icon>
          </div>

          <div class="pt-6">
            <h2 class="text-center">
              Pengajuan Sukses
            </h2>

            <p
              style="margin-top: 20px; text-align: center; padding-left: 85px; padding-right: 85px;"
            >
              Tim Dompet Kilat akan segera menghubungi kamu dalam waktu
              <span style="font-weight: bold;">2x24 jam</span> untuk melakukan
              validasi terkait data yang kamu input.
            </p>
          </div>

          <v-card-actions class="py-8"> </v-card-actions>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    dialog: Boolean,
    closeDialog: Function,
  },
};
</script>
